import type { JwtContextData } from './jwt.types';

const CONTEXT_DEFAULT = {
  payload: null,
  token: null,
  tokenError: null,
};

export const JWT_CONTEXT_DATA = <T>(context?: Partial<JwtContextData<T>>) => ({
  ...CONTEXT_DEFAULT,
  ...context,
});
